/**


 */
export class MappingMode
{
	/**
	 *
	 */
	public static NORMAL:string = "normal";

	/**
	 *
	 */
	public static LINEAR_GRADIENT:string = "linearGradient";

	/**
	 *
	 */
	public static RADIAL_GRADIENT:string = "radialGradient";
}